'use client';

import { styled } from '@linaria/react';
import LinkFactory from '@fe-common-utils/libs/link';
import { RectangleSkeleton } from '@fe-common-ui/Skeleton';
import PopTopicDetailInfiniteListSkeleton from '@fe-news/components/molecules/PopTopicDetailInfiniteList/PopTopicDetailInfiniteListSkeleton';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
`;

const UserSelectContainer = styled.div`
  display: flex;
  column-gap: 22px;
  border-bottom: 1px solid #e2e8f1;
  padding-left: 16px;
  padding-bottom: 12px;
  align-items: center;
  overflow-x: scroll;
`;

const MarketSelectContainer = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: center;
  margin-top: 24px;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: #383838;
  row-gap: 16px;
  flex-wrap: wrap;

  p {
    min-width: fit-content;
  }
`;

const NewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  position: relative;
  font-size: 22px;
  letter-spacing: 0.5px;
  color: #000;

  & > h3 {
    font-weight: 600;
  }
`;

const RedBar = styled.div`
  width: 5px;
  height: 22px;
  background-color: #e03f19;
  position: absolute;
  top: 7px;
  left: -25px;
`;

const PortfoliosNewsContentSkeleton = () => {
  const isProduction = LinkFactory.env === 'prod';

  return (
    <Container>
      <UserSelectContainer>
        {Array.from({ length: 5 }).map((_, index) => (
          <RectangleSkeleton key={index} width={90} height={18} borderRadius={3} />
        ))}
      </UserSelectContainer>
      {!isProduction && (
        <MarketSelectContainer>
          <p>篩選市場類別：</p>
          {Array.from({ length: 5 }).map((_, index) => (
            <RectangleSkeleton key={index} width={90} height={36} borderRadius={3} />
          ))}
        </MarketSelectContainer>
      )}
      <NewsContainer>
        <RedBar />
        <h3>相關新聞</h3>
        <PopTopicDetailInfiniteListSkeleton />
      </NewsContainer>
    </Container>
  );
};

export default PortfoliosNewsContentSkeleton;
